import { getCountries } from 'libphonenumber-js';

var AllCountryCodes = getCountries();

export { AllCountryCodes as default };
